import axios from 'axios';
import { api } from '../../../config';
import {
  LOCK_RESOURCE_CLAUSE,
  LOCK_RESOURCE_TYPE_RESPONSE,
} from './lockRespondStatus';

export { LOCK_RESOURCE_CLAUSE, LOCK_RESOURCE_TYPE_RESPONSE };

export const markRespondReadStatus = async ({
  token,
  resource,
  id,
  isRead = true,
}) => {
  if (!token || !resource || !id) {
    throw new Error('Read status requires token, resource, and id');
  }

  await axios.put(
    `${api.API_URL}/${resource}/${id}/read-status?id=${encodeURIComponent(id)}`,
    { isRead: isRead === true },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
